import React from 'react';
import Box from '@cloudscape-design/components/box';
import SpaceBetween from '@cloudscape-design/components/space-between';
import StatusIndicator from '@cloudscape-design/components/status-indicator';

/**
 * Supplier Gateway · Promised Date. The feature is still under development, so
 * this shows an "under development" placeholder.
 */
export default function PromisedDateScreen() {
    return (
        <Box textAlign="center" padding="xxl">
            <SpaceBetween size="s">
                <Box fontSize="display-l">🚧</Box>
                <StatusIndicator type="pending">Under development</StatusIndicator>
                <Box variant="h2">Promised Date</Box>
                <Box color="text-body-secondary">
                    This feature is still being developed and isn&rsquo;t available yet. For access
                    or timelines, please check with your administrator.
                </Box>
            </SpaceBetween>
        </Box>
    );
}
